import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';

import { t } from 'i18next';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ApklausaSumm from '../AcoordionSumm/ApklausaSumm';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import SettingsIcon from '@mui/icons-material/Settings';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import PrimaryButton from '../Button/PrimaryButton';
import { useNavigate } from 'react-router-dom';
import CreatorModal from '../../Modals/CreatorModal';
import { useSupabaseData } from '../../Hooks';
import { translateFormName } from '../../utils/translateFormName';


const PrimaryAccordionCreator = ({ edit, elements, r, hasContent = true, className = '', getAll }) => {
    const [accordionOpen, setAccordionOpen] = React.useState(false);
    const [expanded, setExpanded] = React.useState('');
    const navigate = useNavigate();
    const { create } = useSupabaseData({ name: 'formos_tipai' }, []);


    if (elements.length == 0) {
        return ''
    }
    const handleChange = (panel) => {
        if (panel == expanded) {
            setExpanded('')
        } else {
            setExpanded(panel);
        }
    };
    return (
        <>
            {elements?.map((e, i) => (
                <div key={e.id}>
                    <div className="accordionContainer ">
                        <div className='ApklausuAkord '>
                            <Accordion
                                expanded={expanded === 'panel' + e.id}
                                onChange={() => { handleChange('panel' + e.id) }}
                                // expanded={accordionOpen}
                                style={{ boxShadow: "none" }}>
                                <AccordionSummary
                                    id={e.id}
                                    expandIcon={
                                        <ExpandMoreIcon style={{ cursor: 'pointer' }}
                                            onClick={(ev) => {
                                                handleChange('panel' + e.id)
                                                ev.stopPropagation();
                                            }}
                                        />
                                    }
                                    sx={{ cursor: 'unset !important' }}
                                    className={' Accordion'}
                                >
                                    <div className={' accordionSummary'}>
                                        <div className="apklausaInfo">
                                            <div className="row">
                                                <p className="data">{new Date(e.attributes.validTo).getFullYear()}</p>
                                                <p className={e.attributes.type + " statusas"}>{t(e.attributes.type)}</p>
                                            </div>
                                            <p className="formosPavadinimas">
                                                {translateFormName(e.attributes.formosPavadinimas, t)}
                                            </p>
                                        </div>
                                        <div className={className}>
                                            <div className={"apklaisaSummContainer"}>
                                                <ApklausaSumm
                                                    create={() => {
                                                        create({ ...e.attributes, validTo: new Date(), type: "Nepaviešinta" }).then(() => { r() })
                                                    }}
                                                    id={e.id}
                                                    data={e.attributes}
                                                />
                                                <div className='row apklausaSummMobile'>
                                                    <div className="row spaceBetween apklausaSummMob">
                                                        <div className="row spaceBetween width100 alignCenter">
                                                            <div className="column ">
                                                                <div className="row">
                                                                    <p className="data">{t(new Date(e.attributes.validTo).getFullYear())}</p>
                                                                    <p className={e.attributes.type + " statusas"}>{t(e.attributes.type)}</p>
                                                                </div>

                                                            </div>
                                                            <div className='row apklausaSummIkonos'>
                                                                <div className='column ikonosName'>
                                                                    <ContentCopyIcon
                                                                        style={{ fill: "#665AE1" }}
                                                                        className='margin'
                                                                    />

                                                                </div>
                                                                <div className='column ikonosName'>
                                                                    <SettingsIcon
                                                                        className='margin'
                                                                        onClick={() => {
                                                                            edit(e.id)
                                                                        }}
                                                                        style={{ fill: "#665AE1" }} />

                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            {translateFormName(e.attributes.formosPavadinimas, t)}
                                                        </div>
                                                    </div>

                                                    <div>
                                                        <PrimaryButton
                                                            onClick={() => {
                                                                navigate("/Rezultatai", { state: { filter: { kasPildo: e.attributes.kasPildo } } })
                                                            }}
                                                            endIcon={<ArrowForwardIcon />}
                                                            text='perziureti_rezultatus'
                                                            className='perziuretRezBtn isDidz'
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className={props.classNameElement}>
                                            {props.element}
                                        </div> */}
                                    </div>
                                </AccordionSummary>
                                {hasContent ?

                                    <AccordionDetails className='AccordionDetalilsCont'>
                                        <CreatorModal
                                            id={e.id}
                                            info={e}
                                            getAll={getAll}
                                            reset={() => { setExpanded('') }}
                                        />
                                    </AccordionDetails>
                                    : ""}
                            </Accordion>
                        </div >
                    </div>
                </div>))}
        </>
    )
}
export default PrimaryAccordionCreator
